module.exports = __webpack_public_path__ + "static/img/Deian-Roberts.ab0ca03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Deian-Roberts.jpg
// module id = 3IcE
// module chunks = 0